var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.isLoading && _vm.list.length
    ? _c("div", [
        _c(
          "div",
          { staticClass: "d-flex justify-content-between flex-column" },
          [
            _c(
              "Table",
              {
                staticClass: "leads-table",
                staticStyle: { "margin-top": "1rem" }
              },
              [
                _c(
                  "TableHeader",
                  [
                    _c(
                      "TableRow",
                      { staticClass: "header-loss-cause" },
                      [
                        _c("TableHead", { attrs: { colspan: "2" } }),
                        _vm._v(" "),
                        _c("TableHead", { attrs: { colspan: "1" } }),
                        _vm._v(" "),
                        _c("TableHead", { attrs: { colspan: "1" } }),
                        _vm._v(" "),
                        _c("TableHead", { attrs: { colspan: "1" } }),
                        _vm._v(" "),
                        _c("TableHead", { attrs: { colspan: "7" } }, [
                          _vm._v("MOTIVOS DE PERDA")
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "TableRow",
                      _vm._l(_vm.leadsColumns, function(leadsCol, index) {
                        return _c(
                          "TableHead",
                          { key: `${leadsCol}-${index}` },
                          [
                            _c("ColumnHeader", {
                              attrs: {
                                sort: leadsCol.sort,
                                somatory: leadsCol.somatory,
                                columnName: leadsCol.name,
                                columnKey: leadsCol.key,
                                columnType: leadsCol.columnType,
                                currentColumnFiltered:
                                  _vm.currentColumnFiltered,
                                sortDirection: _vm.sortDirection,
                                dataList: _vm.list
                              },
                              on: {
                                sortListByKey: function($event) {
                                  return _vm.sortListByKey(leadsCol.key)
                                }
                              }
                            })
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "TableBody",
                  _vm._l(_vm.list, function(item, idx) {
                    return _c(
                      "TableRow",
                      { key: `${item}-${idx}` },
                      [
                        _c(
                          "TableCell",
                          [
                            _c("RenderDateColumnValue", {
                              attrs: { value: item.creationDate }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "TableCell",
                          [
                            _c("RenderNameColumnValue", {
                              attrs: {
                                name:
                                  item.primaryCNAECode +
                                  "-" +
                                  item.primaryCNAEDescription
                              }
                            })
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("TableCell", [
                          _vm._v(
                            _vm._s(
                              (item.totalQualified / item.totalLeads) * 100
                            ) + "%\n          "
                          )
                        ]),
                        _vm._v(" "),
                        _c("TableCell", [_vm._v(_vm._s(item.totalLeads))]),
                        _vm._v(" "),
                        _c("TableCell", [_vm._v(_vm._s(item.totalQualified))]),
                        _vm._v(" "),
                        _c("TableCell", [_vm._v(_vm._s(item.totalClosed))]),
                        _vm._v(" "),
                        _c("TableCell", [_vm._v(_vm._s(item.totalMT))]),
                        _vm._v(" "),
                        _c("TableCell", [
                          _vm._v(_vm._s(item.totalLowConsumption))
                        ]),
                        _vm._v(" "),
                        _c("TableCell", [
                          _vm._v(_vm._s(item.totalSCEEWithoutICMSWithBalance))
                        ]),
                        _vm._v(" "),
                        _c("TableCell", [
                          _vm._v(_vm._s(item.totalSCEEExemptWithBalance))
                        ]),
                        _vm._v(" "),
                        _c("TableCell", [
                          _vm._v(_vm._s(item.totalNightIrrigator))
                        ]),
                        _vm._v(" "),
                        _c("TableCell", [_vm._v(_vm._s(item.totalNoHistory))])
                      ],
                      1
                    )
                  }),
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }